
import axios from 'axios'

export async function getLocationGroups(scope){
    return await axios.get(process.env.VUE_APP_API_HOST + '/custom_location_groups', {params:{scope: scope}})
}
